<template>
  <v-container>
    <div
      :class="[`text-subtitle-1`]"
    >
      <h4>Language(s)</h4>
    </div>
    <v-row
      v-for="(item, i) in lang_list"
      :key="i"
    >
      <v-col
        cols="4"
        md="2"
      >
        {{ lang_list[i].language }}
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <span style="text-transform:capitalize;">{{ lang_list[i].level }}</span>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'AppLanguage',
  props: ['lang_list', 'remove_lang'],
  data: () => ({ }),
  methods: { },
}
</script>